<template>
  <el-dialog
      :title="$t('text.creditLimitChangeRecord')"
      :visible="isShowCardTransactionFlowDialog"
      width="1300px"
      @close="closeDialog"
  >
    <el-table :data="data" v-loading="loading">

      <el-table-column :label="$t('text.anomalyDataTime')" prop="customerName" width="150px" align="center">
        <template slot-scope="{ row }">
          {{ $formatter.formatDate(null, null, row.createDate + row.createTime, null) }}
        </template>
      </el-table-column>

      <el-table-column
          prop="transType"
          :label="$t('text.transactionType')"
          width="90px"
          :formatter="$formatter.formatTransType"
          align="center"
      >
        <template slot-scope="{ row }">
          <el-tag
              size="small"
              :type="
                  row.transType === '20' ||
                  row.transType === '30'
                    ? 'warning'
                    : row.transType === '11' || row.transType === '10'
                    ? 'success'
                    : 'primary'
                "
          >{{
              $formatter.formatCardTransType(null, null, row.transType, null)
            }}</el-tag
          >
        </template>
      </el-table-column>

      <el-table-column
          prop="orderAmount"
          :formatter="$formatter.FenToYuanToThousandth"
          width="130px"
          :label="$t('text.transactionAmount')"
          align="center"
      ></el-table-column>

      <el-table-column
          prop="actualAmount"
          :formatter="$formatter.FenToYuanToThousandth"
          width="130px"
          :label="$t('text.changeAmount')"
          align="center"
      ></el-table-column>

      <el-table-column
          width="90px"
          prop="balanceTrend"
          :label="$t('text.changeType')"
          align="center"
      >
        <template slot-scope="{ row }">
          <el-tag v-if="row.balanceTrend === '1'" type="success" size="mini"
          >{{ $t('balanceTrend.1') }}</el-tag
          >
          <el-tag v-else type="danger" size="mini">{{ $t('balanceTrend.-1') }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column
          prop="currentBalance"
          width="140px"
          :formatter="$formatter.FenToYuanToThousandth"
          :label="$t('text.afterBalance')"
          align="center"
      ></el-table-column>

      <el-table-column
          prop="balanceVersion"
          width="80px"
          :label="$t('text.balanceVersion')"
          align="center"
      ></el-table-column>

      <el-table-column width="150" prop="remark" :label="$t('text.remark')" align="center">
        <template slot-scope="{ row }">
          <div v-if="row.remark">
            <el-popover
                v-if="row.remark && row.remark.length > 10"
                placement="top-start"
                width="150"
                trigger="hover"
                :content="row.remark"
            >
              <div slot="reference" class="remark">
                {{ row.remark }}
              </div>
            </el-popover>
            <div v-else>{{ row.remark }}</div>
          </div>
          <div v-else>--</div>
        </template>
      </el-table-column>

      <el-table-column
          width="140px"
          prop="transactionId"
          :label="$t('text.transactionSn')"
          align="center"
      ></el-table-column>

      <el-table-column
          width="150px"
          prop="tradeId"
          :label="$t('text.traceId')"
          align="center"
      >
        <template slot-scope="{ row }">
          <div v-if="row.tradeId">
            <el-popover
                v-if="row.tradeId && row.tradeId.length > 10"
                placement="top-start"
                width="150"
                trigger="hover"
                :content="row.tradeId"
            >
              <div slot="reference" class="remark">
                {{ row.tradeId }}
              </div>
            </el-popover>
            <div v-else>{{ row.tradeId }}</div>
          </div>
          <div v-else>--</div>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>

export default {
  props: {
    isShowCardTransactionFlowDialog: Boolean,
    cardTransactionFlowData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      formLabelWidth: "100px",
      data: [],
      loading: false,
    }
  },
  created() {
    this.axios.get("/cardTransactionFlow/selectList", {params: {cardId:this.cardTransactionFlowData.cardId}})
        .then(res => {
          if (res.code === 200) {
            this.data = res.data.list;
            console.log(this.data)
          } else {
            this.$notify.error({
              title: this.$t('text.operationFailed'),
              message: res.msg,
            });
            this.closeDialog()
          }
        }).finally(() => {
      this.loading = false;
    })
  },
  methods: {
    closeDialog() {
      this.$emit('update:isShowCardTransactionFlowDialog', false);
    },
    confirm() {
      this.loading = true
    },
  }
}
</script>

<style scoped>

.remark {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

</style>
